import React, { memo, useRef } from 'react';
import { OverlayPanel } from 'primereact/overlaypanel';
import { Divider } from 'primereact/divider';
import useEffectOnce from './hooks/useEffectOnce';
import { useDispatch, useSelector } from 'react-redux';
import { Headerdata } from './reduxactions/donorrsactions/DProfileAction';
import { RootState } from './reducers';
import { publicHashUrl } from './publicUrl';

const imageName = require('./assets/img/gfn.png');
const imageuser = require('./assets/images/images.png');

export const OHeader = () => {
  const op = useRef<OverlayPanel | null>(null);
  const userid = window.sessionStorage.getItem('userid');
  const usertype = window.sessionStorage.getItem('usertype');
  const headerdata = useSelector((state: RootState) => state.dprofile.headerdata);
  const dispatch = useDispatch();

  useEffectOnce(() => {
    const fetchDataAsync = async () => {
      try {
        await dispatch(Headerdata(userid, usertype) as any);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchDataAsync();
  }, [dispatch]);

  const handleLogout = () => {
    op.current?.hide();
    window.sessionStorage.removeItem('usertype');
  };

  const closeMenu = () => {
    op.current?.hide();
  };

  return (
    <div className="layout-topbar app-topbar app-topbar--org">
      <div className="layout-topbar-logo">
        <img src={imageName} alt="GearForNeed logo" width="220" />
      </div>
      <div className="app-topbar-spacer" />
      <ul className="app-user-nav">
        {headerdata.map((response: any) => {
          const photo = typeof response.photo === 'string' ? response.photo : '';
          const fallbackImage =
            !photo ||
              (photo.includes('/profile/') &&
                (photo.split('/profile/')[1] ?? '').trim() === '')
              ? imageuser
              : photo;

          return (
            <li key={response.id}>
              <a
                className="nav-link app-user-trigger"
                data-testid="org-userimage"
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  op.current?.toggle(e);
                }}
              >
                <img src={fallbackImage} className="avatar" alt={response.name} />
                <span className="hidden-xs app-user-name">{response.name}</span>
              </a>
            </li>
          );
        })}

        <OverlayPanel ref={op}>
          <div className="app-overlay-links">
            {usertype === 'organisation' && (
              <>
                <a href={publicHashUrl('/oprofile')} data-testid="org-profile-link" onClick={closeMenu}>
                  Profile
                </a>
                <Divider />
                <a href={publicHashUrl('/oreset')} data-testid="org-reset-link" onClick={closeMenu}>
                  Reset
                </a>
                <Divider />
              </>
            )}
            <a href="/member/" data-testid="org-logout-link" onClick={handleLogout}>
              Sign out
            </a>
          </div>
        </OverlayPanel>
      </ul>
    </div>
  );
};

OHeader.displayName = 'AppTopbar';

export default memo(OHeader);
